export const BuildInfo = {timestamp:1787949827000}
